exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3EP6HNJnG8h4iV{font-size:16px;margin-bottom:2em}", ""]);

// exports
exports.locals = {
	"question": "_3EP6HNJnG8h4iV"
};